import {useCallback, useMemo, useState} from "react";
import {APIv1} from "../../api";
import LogsPaymentContent from "./LogsPaymentContent";
import LogsConfirmContent from "./LogsConfirmContent";

const LOG_EXPAND_KEY = 'log-expand';

const mapLogContent = (content = {}) => ({
    paymentHeaders: content.payment?.headers,
    paymentRequest: content.payment?.request,
    paymentResponse: content.payment?.response,
    confirmHeaders: content.confirm?.headers,
    confirmRequest: content.confirm?.request,
    confirmResponse: content.confirm?.response,
});

export default function LogsContentSections({t, token, logsData, onContentLoaded}) {
    const [expandedPaymentSection, setExpandedPaymentSection] = useState(null);
    const [expandedConfirmSection, setExpandedConfirmSection] = useState(null);
    const [contentData, setContentData] = useState({});
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [isContentLoading, setIsContentLoading] = useState(false);

    const logsDataWithContent = useMemo(() => ({
        ...logsData,
        ...contentData,
    }), [logsData, contentData]);
    const logId = logsData?.id ?? logsData?.key;

    const fetchContent = useCallback(async () => {
        if (isContentLoaded || isContentLoading || !logId || !token) return;

        setIsContentLoading(true);

        try {
            const response = await APIv1.get(`payment/logs/content/?idx=${encodeURIComponent(logId)}`, {
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            const mappedContent = mapLogContent(response.data?.data);

            setContentData(mappedContent);
            setIsContentLoaded(true);
            onContentLoaded?.(mappedContent);
        } catch (error) {
            console.log('Something went wrong:', error);
        } finally {
            setIsContentLoading(false);
        }
    }, [isContentLoaded, isContentLoading, logId, onContentLoaded, token]);

    const togglePaymentSection = useCallback((section) => {
        const nextSection = expandedPaymentSection === section ? null : section;
        if (nextSection === LOG_EXPAND_KEY) fetchContent();
        setExpandedPaymentSection(nextSection);
    }, [expandedPaymentSection, fetchContent]);

    const toggleConfirmSection = useCallback((section) => {
        const nextSection = expandedConfirmSection === section ? null : section;
        if (nextSection === LOG_EXPAND_KEY) fetchContent();
        setExpandedConfirmSection(nextSection);
    }, [expandedConfirmSection, fetchContent]);

    return (
        <>
            <div className="payment-log__grid">
                <div className="payment-log__section">
                    <LogsPaymentContent
                        t={t}
                        expandedSection={expandedPaymentSection}
                        logsData={logsDataWithContent}
                        toggleSection={togglePaymentSection}
                    />
                </div>
            </div>

            <div className="payment-log__grid">
                <div className="payment-log__section">
                    <LogsConfirmContent
                        t={t}
                        expandedSection={expandedConfirmSection}
                        logsData={logsDataWithContent}
                        toggleSection={toggleConfirmSection}
                    />
                </div>
            </div>
        </>
    );
}
